export { default } from "./CompanyLogoCard";
